var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "public-title-components" }, [
    _c(
      "div",
      { staticClass: "page_title" },
      [
        _c("custom-breadcrumb", {
          attrs: { suffix: "# " + _vm.serviceOrderId }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "public-title-steps" },
      [
        _c(
          "el-steps",
          { attrs: { active: _vm.active, "align-center": "" } },
          [
            _c("el-step", {
              attrs: { title: "Apply for a refund", icon: "el-icon-success" }
            }),
            _vm._v(" "),
            _c("el-step", {
              attrs: { title: "Refund Under Review", icon: "el-icon-success" }
            }),
            _vm._v(" "),
            _c("el-step", {
              attrs: { title: "Completed", icon: "el-icon-success" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "shipped-content-title" }, [
      _c("div", { staticClass: "shipped-content" }, [
        _c("div", { staticClass: "shipped-content-title medium" }, [
          _vm.active === 2
            ? _c("div", [_vm._v("Refund Under Review")])
            : _vm._e(),
          _vm._v(" "),
          _vm.active === 3 ? _c("div", [_vm._v("Completed")]) : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26e9bd1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e9bd1f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/public-title.vue
// module id = /poo
// module chunks = 2